<div *ngIf="errors.length > 0" class="console-error-panel" [class.open]="open" [class.left]="position === 'left'" [class.right]="position === 'right'">
  <div class="console-error-header" (click)="togglePanel()">
    <span>Console Errors ({{ errors.length }})</span>
    <span class="header-actions" (click)="$event.stopPropagation()">
      <ng-container *ngIf="!open">
        <button pButton type="button" class="p-button-text p-button-sm position-toggle-btn" (click)="togglePosition($event)" title="Toggle panel position">
          <span *ngIf="position === 'left'" class="pi pi-arrow-right"></span>
          <span *ngIf="position === 'right'" class="pi pi-arrow-left"></span>
        </button>
        <button pButton type="button" class="p-button-text p-button-sm close-btn-x" (click)="clearAll($event)" title="Clear all messages">
          <span class="pi pi-times"></span>
        </button>
      </ng-container>
      <ng-container *ngIf="open">
        <button pButton type="button" class="p-button-text p-button-sm copy-all-btn" 
                [disabled]="errors.length <= 1" 
                (click)="copyAllErrors($event)" 
                title="Copy all errors">
          <span class="pi pi-copy"></span> Copy All
        </button>
        <button pButton type="button" class="p-button-text p-button-sm expand-btn" (click)="toggleFullscreen($event)" title="Expand to fullscreen">
          <span class="pi pi-window-maximize"></span>
        </button>
        <button pButton type="button" class="p-button-danger p-button-sm close-btn" (click)="clearAll($event)">Clear All</button>
      </ng-container>
    </span>
  </div>
  <div class="console-error-list" #errorList>
    <div class="console-error-item" *ngFor="let error of errors">
      <div class="console-error-summary">
        <span>{{ error.message }}</span>
        <button pButton type="button" class="p-button-text p-button-sm p-button-secondary" (click)="copyError(error, $event)" title="Copy error details">
          <span class="pi pi-copy"></span>
        </button>
        <button pButton type="button" class="p-button-text p-button-sm p-button-secondary" (click)="toggleExpand(error, $event)">
          {{ error.expanded ? 'Hide' : 'Show More' }}
        </button>
        <button pButton type="button" class="p-button-text p-button-sm p-button-danger" (click)="remove(error.id, $event)">
          Dismiss
        </button>
      </div>
      <div class="console-error-detail" *ngIf="error.expanded">
        <pre>{{ error.stack }}</pre>
      </div>
    </div>
  </div>
</div>

<!-- Fullscreen Error Panel -->
<div *ngIf="fullscreen" class="console-error-fullscreen-overlay" (click)="closeFullscreen()">
  <div class="console-error-fullscreen-panel" (click)="$event.stopPropagation()">
    <div class="console-error-fullscreen-header">
      <span>Console Errors - Fullscreen View ({{ errors.length }})</span>
      <div class="fullscreen-header-actions">
        <button pButton type="button" class="p-button-text p-button-sm copy-all-fullscreen-btn" 
                [disabled]="errors.length <= 1" 
                (click)="copyAllErrors($event)" 
                title="Copy all errors">
          <span class="pi pi-copy"></span> Copy All
        </button>
        <button pButton type="button" class="p-button-text p-button-sm close-fullscreen-btn" (click)="closeFullscreen()" title="Close fullscreen">
          <span class="pi pi-window-minimize"></span>
        </button>
        <button pButton type="button" class="p-button-danger p-button-sm" (click)="clearAll($event)">Clear All</button>
      </div>
    </div>
    <div class="console-error-fullscreen-content">
      <div class="console-error-fullscreen-item" *ngFor="let error of errors">
        <div class="console-error-fullscreen-summary">
          <span class="error-message">{{ error.message }}</span>
          <div class="fullscreen-error-actions">
            <button pButton type="button" class="p-button-text p-button-sm p-button-secondary" (click)="copyError(error, $event)" title="Copy error details">
              <span class="pi pi-copy"></span>
            </button>
            <button pButton type="button" class="p-button-text p-button-sm p-button-danger" (click)="remove(error.id, $event)">
              Dismiss
            </button>
          </div>
        </div>
        <div class="console-error-fullscreen-stack">
          <pre>{{ error.stack }}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
